// The API sends a billed period as an ISO range. A label it could not read comes through as it
// was written, and is shown as it is.
const PERIOD = /^(\d{4}-\d{2}-\d{2}) - (\d{4}-\d{2}-\d{2})$/

export function formatPeriod(period: string, locale: string): string {
  const parts = PERIOD.exec(period.trim())
  if (!parts) return period

  const start = new Date(`${parts[1]}T00:00:00Z`)
  const end = new Date(`${parts[2]}T00:00:00Z`)
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()))
    return period

  // A whole calendar month is what most invoices bill, and its name reads better than its ends.
  if (isWholeMonth(start, end)) {
    return capitalize(
      start.toLocaleDateString(locale, {
        month: 'long',
        year: 'numeric',
        timeZone: 'UTC'
      })
    )
  }

  return `${formatDate(start, locale)} - ${formatDate(end, locale)}`
}

export function formatDate(date: Date, locale: string): string {
  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
  })
}

export function formatAmount(
  totalInCents: number,
  currency: string,
  locale: string
): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: (currency || 'eur').toUpperCase()
  }).format(totalInCents / 100)
}

function isWholeMonth(start: Date, end: Date): boolean {
  const lastDay = new Date(
    Date.UTC(end.getUTCFullYear(), end.getUTCMonth() + 1, 0)
  )
  return (
    start.getUTCFullYear() === end.getUTCFullYear() &&
    start.getUTCMonth() === end.getUTCMonth() &&
    start.getUTCDate() === 1 &&
    end.getUTCDate() === lastDay.getUTCDate()
  )
}

function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1)
}
